module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Right Chaise.d1b8583e.jpg";